import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';
import { firebase } from '../utils/firebase';
import Checkout from '../checkout';

class date extends Component {
    constructor() {
        super()

        this.onHandleChange = this.onHandleChange.bind(this)

        this.state = {
            dateNumber: 0,
            dateVal: 0,
        }
    }
   
    render() {
        return (
           <div>
    
                <Label for="ownership">Date formatted</Label>
                <FormGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
                <Input type="date" name="dateNumber" defaultValue={""} onChange={this.onHandleChange} />
                </FormGroup>
                <Label>{(new Date(this.state.dateNumber).getTime()+86400000)}</Label>

                <br/>
                <br/>
                <Label>Date in number format</Label>
                <Input type="number" name="dateVal" onChange={this.onHandleChange}/>
                <Label>{(new Date(parseInt(this.state.dateVal,10)).toLocaleString())}</Label>
            
            </div>
        )//return
    }

    onHandleChange(e) {
        var value = e.target.value;
        var name = e.target.name;
        this.setState({
            [name]: value,
          })
    }
}

export default date


// WEBPACK FOOTER //
// ./src/components/date.js